




























































import { Vue, Prop, Component } from 'vue-property-decorator';
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

import { fetchMS } from '../fetchMS';

@Component({
  components: {
    FormFieldsContainer,
  },
})
export default class ModalDevolverSeriado extends Vue {
  @Prop({ required: true, default: {} }) data!: {
    asignumero?: string;
    epc?: string;
    estado_inventario?: string;
    estado_preparacion?: string;
    fecha_bateria?: moment.Moment | string;
    id?: string;
    modalidad?: string;
    plataforma?: string;
    sereactivainet_flagok?: string;
    serieactivaavl?: string;
    serieactivafecha_alta?: moment.Moment | string;
    serieactivaid_dispositivo?: string;
    serieactivainet_movimientonro?: string;
    serieactivamodalidad?: string;
    serieactivanro?: string;
    serieactivaobs?: string;
    serieactivaplata_fecha?: moment.Moment | string;
    serieactivaplata_ingresada?: string;
    serieactivaplataforma?: string;
    serienumero?: string;
    simserienumero?: string;
    tipoeq?: string;
    tipoeqid?: string;
    serieactiva_novalido?: string;
    serieactiva_motivoid?: string;
    serieactiva_motivoobs?: string;
    serieactiva_finalizada?: string;
  };
  @Prop({ required: false, default: false }) dialog!: boolean;
  @Prop({ required: true, default: null }) funcionalidad!: Funcionalidades;

  // Variables Globales
  disabledForm: boolean = false;
  contErrors: number = 0;
  loading: boolean = false;

  statusList: string[] = [];
  disabledFiled: Record<string, boolean> = {
    btnSave: false,
  };
  objParam: {
    motivo: {
      serieactiva_motivoid: string;
      val: string;
    };
    serieactiva_motivoobs: string;
  } = {
    motivo: {
      serieactiva_motivoid: '',
      val: '',
    },
    serieactiva_motivoobs: '',
  };

  userId: string = JSON.parse(window.localStorage.user).id;
  rut: string = localStorage.getItem('clienteDefecto');
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  async mounted() {
    try {
      this.loading = true;
      await Promise.all([this.getSateate(), this.initialValues()]);
    } catch (err) {
      console.error('Error: ', err);
    } finally {
      this.loading = false;
    }
  }

  initialValues() {
    this.objParam.serieactiva_motivoobs = this.data.serieactiva_motivoobs;

    this.disabledFiled.btnSave =
      !this.data.serieactiva_motivoobs || !this.data.serieactiva_motivoid
        ? true
        : false;

    // Validamos si el campo serieactiva_novalido es true significaría que ya ha sido devuelto, tambien el campo serieactiva_finalizada no debe haber sido finalizado
    this.disabledForm =
      this.data.serieactiva_novalido === 't' ||
      this.data.serieactiva_finalizada === 'Finalizado'
        ? true
        : false;
  }

  handleSend() {
    // Validar que todos los campos tengan un valor
    const allHasVal: boolean = Object.values(this.objParam).every(val => !!val);
    this.disabledFiled.btnSave = !allHasVal;
  }

  // Validacion de los valores en los inputs
  rules = {
    descripcion: (val: any) => {
      if (!val || !val.trim()) {
        return this.ruleValue('El campo Descripción es obligatorio');
      }
      if (val.length > 350) {
        return this.ruleValue('Solo se permite un máximo de 350 caracteres');
      }
      return this.ruleValue();
    },
    motivo: (val: any) =>
      !val.serieactiva_motivoid || !val.val
        ? this.ruleValue(
            'El campo Motivo de Devolución es un campo obligatorio'
          )
        : this.ruleValue(),
  };

  ruleValue(msg: string = '') {
    if (msg) {
      this.contErrors++;
      this.disabledFiled.btnSave = true;
      return `${msg}`;
    }
    this.contErrors !== 0 && this.contErrors--;
    if (this.contErrors === 0) {
      this.disabledFiled.btnSave = false;
    }
    return true;
  }

  // Cerrar el Modal de las Series
  closeModal({ reload = false }: { reload?: boolean }) {
    //this.dialog = false;
    this.$emit('closeModalSeriado', reload);
  }

  async getSateate() {
    try {
      this.loadingService.showLoading(undefined, 'getSateate');
      const result = await fetchMS({}, 'get_return_status');
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, FILTER } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.statusList = FILTER;
      if (this.statusList.length > 0) {
        let motivo: any = undefined;
        if (this.data.serieactiva_motivoid) {
          motivo = this.statusList.find(
            (x: any) =>
              x.serieactiva_motivoid === this.data.serieactiva_motivoid
          );
        }
        if (motivo) {
          this.objParam.motivo = motivo;
        }
      }
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('getSateate');
    }
  }

  handleReturnSerie() {
    if (this.data.serieactiva_novalido === 't') {
      this.$snotify.error('El equipo ha sido devuelto anteriormente', {
        timeout: 3000,
      });
      return;
    }
    if (this.data.serieactiva_finalizada === 't') {
      this.$snotify.error('El Ya se encuentra finalizado');
      return;
    }
    let emptyField: boolean = false;
    let validate: any = this.objParam;
    for (let key in this.objParam) {
      if (!validate[key]) {
        this.$snotify.error('Todos los campos son obligatorios', {
          timeout: 3000,
        });
        emptyField = true;
        return;
      }
    }
    if (!emptyField) {
      this.returnSerie();
    }
  }

  async returnSerie() {
    try {
      this.loadingService.showLoading(undefined, 'returnSerie');

      let body: any = {
        serienumero: this.data.serienumero,
        asignumero: this.data.asignumero,
        user_id: this.userId,
        rut: this.rut,
        funcionalidad: this.funcionalidad,
        current_data: { ...this.data },
        ...this.objParam,
      };

      const result = await fetchMS(body, 'return_serie');
      const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = result.data;
      const cod: number = parseInt(CODIGO_RESPUESTA);
      if (cod !== 1) {
        throw new Error(MENSAJE_RESPUESTA);
      }
      this.$snotify.success(MENSAJE_RESPUESTA);
      this.closeModal({ reload: true });
    } catch (err) {
      if (
        err instanceof Error &&
        err.message &&
        err.message !== 'Network Error'
      ) {
        this.$snotify.error(err.message, { timeout: 3000 });
        return;
      }
      this.$snotify.error(
        'Ha ocurrido un error al finalizar Requerimiento, por favor intente nuevamente',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading('returnSerie');
    }
  }
}
